import React, { forwardRef, useState } from 'react';
import { useComponentDefaultProps, rem } from '@mantine/styles';
import { useDidUpdate } from '@mantine/hooks';
import { ImageIcon } from './ImageIcon.js';
import useStyles from './Image.styles.js';
import { Box } from '../Box/Box.js';
import { Text } from '../Text/Text.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  fit: "cover",
  width: "100%",
  height: "auto",
  radius: 0
};
const Image = forwardRef((props, ref) => {
  const _a = useComponentDefaultProps("Image", defaultProps, props), {
    className,
    alt,
    src,
    fit,
    width,
    height,
    radius,
    imageProps,
    withPlaceholder,
    placeholder,
    imageRef,
    classNames,
    styles,
    caption,
    unstyled,
    style,
    variant
  } = _a, others = __objRest(_a, [
    "className",
    "alt",
    "src",
    "fit",
    "width",
    "height",
    "radius",
    "imageProps",
    "withPlaceholder",
    "placeholder",
    "imageRef",
    "classNames",
    "styles",
    "caption",
    "unstyled",
    "style",
    "variant"
  ]);
  const { classes, cx } = useStyles({ radius }, { classNames, styles, unstyled, name: "Image", variant });
  const [error, setError] = useState(!src);
  const isPlaceholder = withPlaceholder && error;
  useDidUpdate(() => {
    setError(!src);
  }, [src]);
  return /* @__PURE__ */ React.createElement(Box, __spreadValues({
    className: cx(classes.root, className),
    style: __spreadValues({ width: rem(width) }, style),
    ref
  }, others), /* @__PURE__ */ React.createElement("figure", {
    className: classes.figure
  }, /* @__PURE__ */ React.createElement("div", {
    className: classes.imageWrapper
  }, /* @__PURE__ */ React.createElement("img", __spreadProps(__spreadValues({
    src,
    alt,
    ref: imageRef
  }, imageProps), {
    className: cx(classes.image, imageProps == null ? void 0 : imageProps.className),
    onError: (event) => {
      setError(true);
      typeof (imageProps == null ? void 0 : imageProps.onError) === "function" && imageProps.onError(event);
    },
    style: __spreadValues(__spreadValues({
      objectFit: fit,
      width: rem(width),
      height: rem(height)
    }, isPlaceholder && { overflow: "hidden" }), imageProps == null ? void 0 : imageProps.style)
  })), isPlaceholder && /* @__PURE__ */ React.createElement("div", {
    className: classes.placeholder,
    title: alt
  }, placeholder || /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ImageIcon, {
    width: rem(40),
    height: rem(40)
  })))), !!caption && /* @__PURE__ */ React.createElement(Text, {
    component: "figcaption",
    size: "sm",
    align: "center",
    className: classes.caption
  }, caption)));
});
Image.displayName = "@mantine/core/Image";

export { Image };
//# sourceMappingURL=Image.js.map
